export default {
  version: "sjd7-ukps",
};
